import PropTypes from 'prop-types';

export const ApplyUpdatesWrapperPropTypes = {
  id: PropTypes.number.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export const ApplyUpdatesPropTypes = {
  onForceRerender: PropTypes.func.isRequired,
  ...ApplyUpdatesWrapperPropTypes,
};
